<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-flex align-items-center"></div>
      <div class="d-sm-flex align-items-center">
        <button @click="telecharger" v-if="valideEtape3" :disabled="isLoading"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          <span v-if="!isLoading">Exporter</span>
          <span v-else>
            <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            Export en cours...
          </span>
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <div class="row">
          <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot clé
              </label>
              <Field
                style="max-height: 42px"
                v-model="motCle"
                name="mot"
                type="text"
                aria-disabled="true"
                class="form-control shadow-none fs-md-15 text-black"
                placeholder="Recherche par mot clé"
              />
              <ErrorMessage name="mot" class="text-danger" />
            </div>
          </div>

          <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Secteur2 
              </label>
              <Field name="secteur" v-model="secteur" v-slot="{ field }">
                <Multiselect
                  :options="secteursOptions"
                  :searchable="true"
                  v-bind="field"
                  placeholder="Sélectionner un secteur"
                />
              </Field>
              <ErrorMessage name="secteur" class="text-danger" />
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Secteur
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                N° place
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Locataire
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Exploitant
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Loyer
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Arrièrés
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contrat, index) in contratEmplacements" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ contrat.libelle_secteur }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ contrat.ncode_emp }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contrat.usagerLocataire }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contrat.exploitant }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatWithThousandSeparator(contrat.loyer) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatWithThousandSeparator( contrat.too ? contrat.too : "0") }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span
                    class="badge text-white bg-primary fs-15 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Actions
                    <i
                      class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"
                    ></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('AddArriere')">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#AddArrieresModal"
                        @click="ajoutArr(contrat.id)"
                      >
                        <i
                          class="flaticon-check lh-1 me-8 position-relative top-1"
                        ></i>
                        Ajouter un arrièré
                      </a>
                    </li>
                    <li v-if="checkPermission('ViewArriereElectronic')">
                      <a
                        type="button"
                        class="dropdown-item d-flex align-items-center"
                        @click="ajoutArr(contrat.id)"
                        data-bs-toggle="modal"
                        data-bs-target="#VoirDetails"
                      >
                        <i
                          class="flaticon-view lh-1 me-8 position-relative top-1"
                        ></i>
                        Détails
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
  <AddArrieresModal
    :item="selectedItem"
    @close="recharger"
    :type="typeT"
    @openmodal="show_Modal"
  />
  <VoirDetails
    :item="selectedItem"
    @close="recharger"
    @openmodal="show_Modal"
  />
</template>
  <script lang="ts">
import { ref, defineComponent, onMounted, watch } from "vue";
import AddArrieresModal from "./AddArrieresModal.vue";
import VoirDetails from "./VoirDetails.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { showModal, suppression, separateur, error, checkPermission, getUrlApiForFiles, downloadExcel } from "@/utils/utils";
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import Multiselect from "@vueform/multiselect";
import axios from "axios";

export default defineComponent({
  name: "ListeContrat",
  components: {
    AddArrieresModal,
    PaginationComponent,
    VoirDetails,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: () => {
    const contrats = ref<Array<Contrat>>([]);
    const contrat = ref<Contrat>();
    const selectedItem = ref(0);
    const secteur = ref("");

    // BEGIN PAGINATE
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const secteursOptions = ref<Array<Option>>([]);
    const motCle = ref("");
    const typeT = ref("Ajout");
    // END PAGINATE
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (error) {
        //
      }
    };
    function rechercher() {
      // getAllContrat(page.value, limit.value, searchTerm.value );
    }
    function formatWithThousandSeparator(num: string): string {
      const num2 = parseFloat(num);
      return num2.toLocaleString("fr-FR");
    }

    const recharger = () => {
      actionRecherche(page.value, limit.value);
    };
    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    const recupereSecteurs = async () => {
      try {
        const response = await axios.get("/secteur");
        const donneee = response.data.data;
        secteursOptions.value = donneee.map((secteur) => ({
          label: `${secteur.code_secteur} -- [ ${secteur.libelle_secteur} ]`,
          value: secteur.code_secteur,
          disabled: false,
        }));
        return secteursOptions.value;
      } catch (error) {
        //
      }
    };
    const contratEmplacements = ref([]);

    const actionRecherche = async (page = 1, limi = 10, searchTerm = "") => {
      // if(secteur.value == ''){
      //   error("Veuillez selectionnez un secteur")
      //   return;
      // }else{
      const element = {
        secteur: secteur.value,
        motCle: motCle.value,
        page: page,
        totalPages: totalPages.value,
        limit: limi,
        totalElements: totalElements.value,
        mot: searchTerm,
    
      };
      try {
        const response = await axios.post("/contrat", element);
        contratEmplacements.value = response.data.data.data;
        totalPages.value = response.data.data.totalPages;
        limit.value = response.data.data.limit;
        totalElements.value = response.data.data.totalElements;
      } catch (error) {
        //
      }
    };
    // }
    const ajoutArr = (id: number) => {
      selectedItem.value = id;
    };

    watch(secteur, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      secteur.value = newValue;
      actionRecherche(page.value, limit.value);
    });

    watch(motCle, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        motCle.value = newValue;
        actionRecherche(page.value, limit.value);
      }
    });
    onMounted(() => {
      recupereSecteurs();
      // actionRecherche(1, 10);
      recharger();
    });

    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    
    // Variables pour l'export
    const valideEtape3 = ref(true);
    const isLoading = ref(false);

    const telecharger = async () => {
      valideEtape3.value = false;
      isLoading.value = true;
      try {
        const element = {
          motCle: motCle.value,
          secteur: secteur.value,
        };
        const response = await axios.post("/contrat/arrieres/export", element);
        const downloadUrl = await getUrlApiForFiles("Excel", response.data.data + ".xlsx");

        await downloadExcel(downloadUrl);
        openNewWindow({ reference: (response.data.data) }, "Excel");
        valideEtape3.value = true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
        valideEtape3.value = true;
      } finally {
        isLoading.value = false;
      }
    };

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };

    function openNewWindow(data: any, dossier = "Excel") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".xlsx"));
    }

    return {
      contrats,
      suppression,
      AddArrieresModal,
      VoirDetails,
      selectedItem,
      recharger,
      show_Modal,
      page,
      secteur,
      secteursOptions,
      totalPages,
      limit,
      separateur,
      totalElements,
      handlePaginate,
      searchTerm,
      rechercher,
      motCle,
      ajoutArr,
      formatWithThousandSeparator,
      typeT,
      contratEmplacements,
      checkPermission,
      telecharger,
      valideEtape3,
      isLoading,
      openNewWindow
    };
  },
});
</script>